import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import {
  BUILDING_OPTIONS_WITH_AVATAR_PARAMS,
  BuildingAsyncMultiValuedList,
} from '../../../Building'
import { isFlatTable, isRequestTable, isUserTable } from '../../Table.utils'
import { ListCell } from '../ListCell'
import { TableCellEditButton } from '../TableCellEditButton'
import { TableTextCell } from '../TableTextCell'

import { getBuildingLabel, getListApiParams } from './TableBuildingCell.utils'

import * as styles from './TableBuildingCell.module.css'

function TableBuildingCell({
  canChange,
  context,
  getApiParams = getListApiParams,
  getLabel = getBuildingLabel,
  id,
  isSingleValue,
  scrollRef,
  value,
  onChangeAddress,
  ...cellProps
}) {
  const { t } = useTranslation()

  const apiParams = isUserTable(context)
    ? {
        ...BUILDING_OPTIONS_WITH_AVATAR_PARAMS,
        exclude_id: value?.id,
        inhabitant: id,
      }
    : getApiParams(id, value)

  const preparedValue = value
    ? [
        { children: getLabel(value) },
        ...Array.from({ length: value.count - 1 }),
      ]
    : null

  const listCellClassName = classNames(styles.cell, cellProps.className)

  return isFlatTable(context) || isRequestTable(context) || isSingleValue ? (
    <TableTextCell {...cellProps} value={getLabel(value)} />
  ) : (
    <ListCell
      {...cellProps}
      List={BuildingAsyncMultiValuedList}
      className={listCellClassName}
      count={value?.count}
      listProps={{ apiParams }}
      scrollRef={scrollRef}
      value={preparedValue}
    >
      {canChange ? (
        <TableCellEditButton
          className={styles.editButton}
          tooltip={t('InhabitantTable.EditAddressBtnKey')}
          onClick={onChangeAddress}
        />
      ) : null}
    </ListCell>
  )
}

export default TableBuildingCell
